import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {OrderList} from "../interface/order-list";
import {OrderCancellationDialogComponent} from "../order-cancellation-dialog/order-cancellation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {OrderListBpm} from "../interface/order-list-bpm";

@Component({
	selector: 'fb-order-list-card',
	templateUrl: './order-list-card.component.html',
	styleUrls: ['./order-list-card.component.scss']
})
export class OrderListCardComponent implements OnChanges {

	@Input()
	public item: OrderListBpm = {} as OrderListBpm;
	public url: string = 'order';
	public today: number = new Date().getTime();
	public msIn24Hours = 24 * 60 * 60 * 1000;

	constructor(
		private _dialog: MatDialog
	) {
	}

	ngOnChanges(changes: SimpleChanges) {
		if(this.item.orderType === 'CUSTOM_ORDER') {
			this.url = 'custom-order';
		}
		else {
			this.url = 'order';
		}
	}

	public cancelOrder(orderId: number): void {
		this._dialog.open(OrderCancellationDialogComponent, {
			data: { orderId: orderId },
			maxWidth: '80vw',
			maxHeight: '90vh'
		});
	}

	public getPercentage(item: number, totalItems: number): string {
		return ((item/totalItems) * 100).toFixed(0);
	}
}
